import { makeStyles, Theme } from "@material-ui/core/styles";
import { rightArrow } from "../../../asset";

const useStyles = makeStyles((theme: Theme) => ({
  tblContainer: {
    // maxHeight:'375px',
  },
  tblHeader: {
    "& th": {
      //  backgroundColor:'#fbfbfb',
      backgroundColor: "#fff",
      color: "#000",
      textTransform: "uppercase",
      fontSize: "12px",
      padding: "10px 5px !important",
      fontWeight: "bold",
    },
  },
  tblBody: {
    "& th": {
      backgroundColor: "#fff",
      color: "#000",
      textTransform: "uppercase",
      fontSize: "12px",
      padding: "6px 5px !important",
      fontWeight: "bold",
    },
    "& td": {
      color: "#000",
      backgroundColor: "#fff;",
      fontSize: "12px",
      padding: "6px 5px !important",
      textTransform: "uppercase",
      borderBottom: "1px solid #ededed !important",
    },
  },
  tblOuterBG: {
    backgroundColor: "#fff;",
    padding: "10px",
    borderRadius: "15px",
  },

  // Status Lables
  statusBlockWrapper: {
    float: "left",
    background: "#fff",
    padding: "10px",
    borderRadius: "55px",
    height: "34px",
    [theme.breakpoints.down("sm")]: {
      height: "70px",
    },
  },

  statusBlockWrapperXs: {
    float: "left",
    background: "#fff",
    padding: "10px",
    borderRadius: "55px",
    height: "34px",
  },

  statusBlock: {
    float: "left",
    margin: "0 0px 0 0",
    // width:'93px',
  },
  allStatus: {
    color: "#fff",
    float: "left",
    border: "2px solid #464646",
    margin: "0 4px 0 0",
    padding: "8px 3px 8px 3px",
    fontSize: "12px",
    background: "#464646",
    borderRadius: "20px",
    width: "70px",
    boxShadow: "1px 1px 30px -5px rgb(0, 0, 0)",
    [theme.breakpoints.down("sm")]: {
      margin: "2px 4px 0 0",
    },
  },
  pendingStatus: {
    color: "#000",
    padding: "10px 7px 8px 6px",
    fontSize: "12px",
    background: "#f8f2eb",
    borderRadius: "20px",
    float: "left",
    // width: '96%',
    border: "1px solid #f98b0b",
    margin: "0 4px 0 0",
    width: "60px",
    [theme.breakpoints.down("sm")]: {
      margin: "2px 4px 0 0",
    },
  },
  blockedStatus: {
    color: "#000",
    padding: "10px 7px 8px 6px",
    fontSize: "12px",
    background: "#fff4f4",
    borderRadius: "20px",
    float: "left",
    // width: '96%',
    border: "1px solid #fe0000",
    margin: "0 4px 0 0",
    width: "60px",
    [theme.breakpoints.down("sm")]: {
      margin: "2px 4px 0 0",
    },
  },
  activeStatus: {
    color: "#000",
    padding: "10px 7px 8px 6px",
    fontSize: "12px",
    background: "#e9f2e0",
    borderRadius: "20px",
    float: "left",
    // width: '96%',
    border: "1px solid #50950b",
    margin: "0 4px 0 0",
    [theme.breakpoints.down("sm")]: {
      margin: "2px 4px 0 0",
    },
  },

  statusLbl: {
    width: "50px",
    textAlign: "left",
    float: "left",
    textTransform: "uppercase",
    fontSize: "8px",
    fontWeight: "bold",
    margin: "3px 0 0 0",
  },
  statusCount: {
    width: "20px",
    textAlign: "right",
    float: "right",
    fontSize: "12px",
    fontWeight: "bold",
  },

  progressWrapper: {
    background: "#e4e4e4",
    width: "100%",
    borderRadius: "30px",
    padding: "10px 10px 10px 10px",
  },
  progressBlock: {
    float: "left",
    margin: "6px 2px 0 0",
  },
  // progressheadeing:{
  //     fontSize:'10px',
  //     fontWeight:'bold',
  //     textTransform:'uppercase',
  //     float:'left',
  //     margin: '10px 0 0 0',
  // },
  progressArrowRight: {
    backgroundImage: `url("${rightArrow}")`,
    float: "left",
    width: "23px",
    height: "8px",
    margin: "8px 0 0 0px",
  },
  cercleGray: {
    float: "left",
    borderRadius: "30px",
    background: "#767676",
    width: "20px",
    height: "20px",
    margin: "0px 5px 0 0",
    border: "2px solid #767676",
    color: "#fff",
  },
  creatVendorIcon: {
    "& .MuiSvgIcon-root": {
      padding: "2px 0 0 0 !important",
      fontSize: "16px",
    },
  },
  cercleGrayTxt: {
    color: "#fff",
    fontWeight: "bold",
    padding: "4px 0 0 6px",
    float: "left",
    fontSize: "12px",
  },
  cercleGrayActive: {
    float: "left",
    borderRadius: "30px",
    background: "#fff",
    width: "20px",
    height: "20px",
    margin: "0px 5px 0 0",
    border: "2px solid #767676",
    color: "#767676",
    "& .MuiSvgIcon-root": {
      padding: "3px 0 0 0 !important",
      fontSize: "14px",
    },
  },
  progreslabel: {
    fontSize: "10px",
    textTransform: "uppercase",
    margin: "7px 2px 0 0",
    float: "left",
  },

  // Filter Section
  filterSection: {
    margin: "10px 0 10px 0",
    "& .MuiTextField-root": {
      fontSize: "2px",
      background: "#fff",
      padding: "0 0 0 0",
      borderRadius: "5px",
      border: "1px solid #333",
      margin: "2px",
      width: "222px",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #ccc",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "0px 0 0 0",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input":
      {
        padding: "6px 4px",
        fontSize: "12px",
      },
    "& .makeStyles-filterSection-149 .MuiTextField-root": {
      border: "1px solid #333",
    },
    "& .makeStyles-root-139 .MuiIconButton-root": {
      padding: "0px 0",
      margin: "0px 0",
    },
    // "& .makeStyles-root-25 .MuiIconButton-root":{

    //     padding: '4px 0',
    // },
  },
  filterheader: {
    fontSize: "14px",
    margin: "0px 0 0 10px !important",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  filterWrapper: {
    width: "100%",
    margin: "0px 0 0 10px !important",
  },
  dataBlock: {
    float: "left",
    width: "275px",
    height: "40px",
    marginBottom: "8px",
  },
  legendSection: {
    float: "right",
    width: "100%",
    justifyContent: "end",
    marginBottom: "8px",
  },
  StatusDetails: {
    color: "#000000",
    marginRight: "12px",
    fontWeight: "bold",
    fontSize: "11px",
  },
  pendingState: {
    borderLeft: "5px solid #f98b0b",
    paddingRight:"8px",
  },
  initialState: {
    borderLeft: "5px solid #12a3ff",
    paddingRight:"8px",
  },
  activeState: {
    borderLeft: "5px solid #81bf49",
    paddingRight:"8px",
  },
  rejectedState: {
    borderLeft: "5px solid #B11C3E",
    paddingRight:"8px",
  },
  cancelledState: {
    borderLeft: "5px solid #8E8A92",
    paddingRight:"8px",
  },
  filterLbl: {
    float: "left",
    margin: "10px 5px 0 0",
    fontSize: "12px",
    width: "120px",
    textTransform: "uppercase",
    fontWeight: "bold",
    textAlign: "left",
  },
  inputWrapper: {
    float: "left",

    "& input": {
      borderRadius: "18px",
      border: "1px solid #ededed",
      padding: "8px 0",
      width: "126px",
      background: "#ededed",
      float: "left",
    },
    "& select": {
      borderRadius: "18px",
      border: "1px solid #ededed",
      padding: "8px 0",
      width: "126px",
      background: "#ededed",
      float: "left",
    },
    "& .MuiOutlinedInput-root": {
      position: "relative",
      border: "unset !important",
      float: "left",
      width: "135px",
      padding: "0px 0",
      background: "#ededed",
      borderRadius: "18px",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 15px 8px 5px",
      fontSize: "12px",
      textAlign: "left",
    },
  },
  tblStatusPending: {
    border: "2px solid #f98b0b",
    color: "#f98b0b",
    borderRadius: "20px",
    textAlign: "center",
    padding: "4px 0 4px 0",
    fontWeight: "bold",
    width: "100px",
    margin: "0 auto",
    fontSize: "12px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      width: "90px",
    },
  },
  tblStatusActive: {
    border: "2px solid #81bf49",
    color: "#81bf49",
    borderRadius: "20px",
    textAlign: "center",
    padding: "4px 0 4px 0",
    fontWeight: "bold",
    width: "100px",
    margin: "0 auto",
    fontSize: "12px",
  },
  tblStatusBlocked: {
    border: "2px solid #e03030",
    color: "#e03030",
    borderRadius: "20px",
    textAlign: "center",
    padding: "4px 0 4px 0",
    fontWeight: "bold",
    fontSize: "12px",
    width: "100px",
    margin: "0 auto",
  },

  tblStatusInitial: {
    border: "2px solid #12a3ff",
    color: "#12a3ff",
    borderRadius: "20px",
    textAlign: "center",
    padding: "4px 0 4px 0",
    fontWeight: "bold",
    fontSize: "12px",
    width: "100px",
    margin: "0 auto",
  },

  tblStatusRejected: {
    border: "2px solid #B11C3E",
    color: "#B11C3E",
    borderRadius: "20px",
    textAlign: "center",
    padding: "4px 0 4px 0",
    fontWeight: "bold",
    fontSize: "12px",
    width: "100px",
    margin: "0 auto", 
    "& .MuiSvgIcon-root": {
      marginRight: "5px",
      marginLeft: "-6px",
      width: "20px !important",
      height: "20px !important",
    },
  },

  tblStatusCancelled: {
    border: "2px solid #8E8A92",
    color: "#8E8A92",
    borderRadius: "20px",
    textAlign: "center",
    padding: "4px 0 4px 0",
    fontWeight: "bold",
    fontSize: "12px",
    width: "100px",
    margin: "0 auto",
  },

  pendingCountTbl: {
    background: "#f98b0b",
    borderRadius: "20px",
    padding: "5px 10px",
    float: "right",
    color: "#fff",
    margin: "-5px 0 0 0",
  },
  approveBtn: {
    fontSize: "12px",
    color: "#50950B",
    float: "left",

    "& .MuiSvgIcon-root": {
      fontSize: "25px !important",
      marginTop: "2px",
      color: "#50950B",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px !important",
      },
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#50950B !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  approveBtnTxt: {
    color: "#50950B",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "7px !important",
      margin: "4px 0 0 0",
    },
  },
  ////////////
  rejectBtn: {
    fontSize: "12px",
    color: "#EA1B1B",
    float: "right",

    "& .MuiSvgIcon-root": {
      fontSize: "25px !important",
      marginTop: "2px",
      color: "#EA1B1B",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px !important",
      },
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#EA1B1B !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  rejectBtnTxt: {
    color: "#EA1B1B",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "7px !important",
      margin: "4px 0 0 0",
    },
  },

  cancelBtn: {
    fontSize: "12px",
    color: "#EA1B1B",

    "& .MuiSvgIcon-root": {
      fontSize: "25px !important", 
      marginTop: "2px",
      color: "#6C6C6D",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px !important",
      },
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#EA1B1B !important",
      padding: "5px 0 0 0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  cancelBtnTxt: {
    color: "#6C6C6D",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "7px !important",
      margin: "4px 0 0 0",
    },
  },

  amendBtn: {
    fontSize: "12px",
    color: "#0088d0",
    float: "left",
    margin: "3px 2px",

    "& .MuiSvgIcon-root": {
      fontSize: "25px !important",
      color: "#0088d0",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px !important",
      },
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#50950B !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  amendBtnTxt: {
    color: "#0088d0",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "7px !important",
      margin: "4px 0 0 0",
    },
  },

  extendBtn: {
    fontSize: "12px",
    color: "#2abb00",
    float: "left",
    margin: "3px 2px",

    "& .MuiSvgIcon-root": {
      fontSize: "28px !important",
      color: "#2abb00",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px !important",
      },
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#50950B !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  extendBtnTxt: {
    color: "#2abb00",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "7px !important",
      margin: "4px 0 0 0",
    },
  },

  unblockBtn: {
    fontSize: "12px",
    color: "#dc9c00",
    float: "left",
    margin: "3px 2px",

    "& .MuiSvgIcon-root": {
      fontSize: "28px !important",
      color: "#dc9c00",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px !important",
      },
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#c98f00 !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  unblockBtnTxt: {
    color: "#c98f00",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "7px !important",
      margin: "4px 0 0 0",
    },
  },

  blockBtn: {
    fontSize: "12px",
    color: "#810000",
    float: "left",
    margin: "3px 2px",

    "& .MuiSvgIcon-root": {
      fontSize: "28px !important",
      color: "#810000",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px !important",
      },
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#50950B !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  blockBtnTxt: {
    color: "#810000",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "7px !important",
      margin: "4px 0 0 0",
    },
  },

  amend: {
    margin: "2px 2px",
    float: "left",
    "& button": {
      borderRadius: "30px",
      background: "#0088d0",
      color: "#fff",
      fontSize: "12px",
      textTransform: "uppercase",
      float: "left",
      //padding: '6px 15px',
      padding: "3px 5px 3px 5px",
      fontWeight: "bold",
      border: "none",
    },
    "& button:hover":{
        backgroundColor:'#0088d0 !important',
      },
    "& .MuiButton-startIcon": {
        display: "inherit",
        marginRight: "1px",
      },
      "& .MuiButton-root" : {
          minWidth:'50px'
      }
  },

  extend: {
    margin: "2px 2px",
    float: "left",
    "& button": {
      borderRadius: "30px",
      background: "#0a8439",
      color: "#fff",
      fontSize: "12px",
      textTransform: "uppercase",
      float: "left",
      //padding: '6px 15px',
      padding: "3px 5px 3px 5px",
      fontWeight: "bold",
      border: "none",
    },
    "& button:hover":{
        backgroundColor:'#0a8439 !important',
      },
    "& .MuiButton-startIcon": {
      display: "inherit",
      marginRight: "1px",
    },
    "& .MuiButton-root" : {
        minWidth:'50px'
    }
  },
  block: {
    margin: "2px 2px",
    float: "left",
    "& button": {
      borderRadius: "30px",
      background: "#b41212",
      color: "#fff",
      fontSize: "12px",
      textTransform: "uppercase",
      float: "right",
      //padding: '6px 15px',
      padding: "3px 5px 3px 5px",
      fontWeight: "bold",
      border: "none",
    },
    "& button:hover":{
        backgroundColor:'#b41212 !important',
      },
    "& .MuiButton-startIcon": {
      display: "inherit",
      marginRight: "1px",
    },
    "& .MuiButton-root" : {
        minWidth:'50px'
    }
  },
  unblock: {
    margin: "2px 2px",
    float: "left",
    "& button": {
      borderRadius: "30px",
      background: "#ad7b00",
      color: "#fff",
      fontSize: "12px",
      textTransform: "uppercase",
      float: "left",
      padding: "6px 10px",
      fontWeight: "bold",
      border: "none",
    },
    "& .MuiButton-startIcon": {
      display: "inherit",
      marginRight: "1px",
    },
  },
  clltoMobile: {
    borderRadius: "30px",
    background: "#fff",
    color: "#2176FF",
    fontSize: "14px",
    textTransform: "uppercase",
    float: "left",
    padding: "4px 16px 4px 16px",
    border: "1px solid #fff",
    boxShadow: "1px 1px 23px -5px rgba(49,182,207,0.73)",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      padding: "4px 8px 0px 8px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "22px !important",
      color: "#2176FF",
      float: "left",
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px !important",
        margin: "4px 0 0 0",
      },
    },
    "& span": {
      float: "left",
      margin: "4px 0 0 0",
      color: "#2176FF",
      fontSize: "12px",
      [theme.breakpoints.down("sm")]: {
        margin: "4px 0 0 0",
        fontSize: "10px !important",
      },
    },
    "& button": {
      background: "#fff",
      border: "none",
      display: "inline-flex",
      [theme.breakpoints.down("sm")]: {
        width: "87px",
      },
    },
    "& button:hover": {
      background: "#fff",
      border: "none",
      [theme.breakpoints.down("sm")]: {
        width: "87px",
      },
    },
  },
  vendorDetailLink: {
    fontSize: "12px",
    fontWeight: "bold",
    background: "#f7f7f7",
    borderRadius: "20px",
    padding: "4px 0",
    minWidth: "98px",
  },
  toolTipLbl: {
    background: "#000",
    color: "#fff",
    padding: "2px 6px",
    margin: "0 0 0 4px",
    borderRadius: "3px",
    cursor: "pointer",
  },
  ArrowGo: {
    "& .MuiSvgIcon-root": {
      fontSize: "18px  !important",
      color: "#c3c3c3 !important",
    },
    "& button": {
      background: "#fff",
      border: "none",
      cursor: "pointer",
    },
  },
  greenBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    "& button": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      color: "#fff",
      fontSize: "12px",
      background: "#00b50a !important",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
    },
  },

  grayBtnWrapper: {
    // margin: "-18px 30px 0 10px",
    "& button": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
    },
  },
  searchBtnWrapper: {
    float: "left",
    "& button": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
      fontWeight: "bold",
    },
    "& button:hover": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
      fontWeight: "bold",
    },
    "& .MuiButton-root": {
      color: "#fff",
      fontSize: "12px",
      background: "#1976d2 !important",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
    },
    "& .MuiButton-root:hover": {
      color: "#fff",
      fontSize: "12px",
      background: "rgb(17, 82, 147) !important",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
    },
  },
  descriptionCell: {
    whiteSpace: "nowrap",
    maxWidth: "110px",
    width: "110px",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
  // greenBtnWrapper:{
  //     float: 'right',
  // margin: '-18px 0px 0 10px',
  //     "& button":{
  //         background: '#19C626 !important',
  // fontSize: '12px',
  // color: '#fff',
  // borderRadius: '20px',
  //     padding: '5px 17px 5px 12px',
  //     fontWeight:'bold',
  // },
  // "& .MuiButton-root:hover":{
  //     color: '#fff',
  //     fontSize: '12px',
  //     background: '#00b50a !important',
  //     borderRadius: '20px',
  //     padding: '5px 17px 5px 12px',
  // },

  // },
}));

export default useStyles;
